document.addEventListener("click", async (event) => {
  if (!event.target) return;

  const target = event.target;
  const quickViewModal = target.closest(".quick-add-modal__content-info");
  const PDPContainer = target.closest(".product-page");

  const squareSwatchEl = target.closest(".product-square-swatch");
  const dropdownOptionEl = target.closest(".product-dropdown-swatch");

  const isSquareSwatch = !!squareSwatchEl;
  const isDropdownSwatch = !!dropdownOptionEl;
  const isPDPOnly = PDPContainer && !quickViewModal;

  if (!(PDPContainer && (isSquareSwatch || isDropdownSwatch))) return;
  event.preventDefault();
  const productWrapper = quickViewModal || PDPContainer;
  const productDataElement = productWrapper.querySelector("[pdp-data-selected-variant]");
  const productData = productDataElement?.innerHTML;
  const parsedProductData = productData ? JSON.parse(productData) : {};

  let variantId;
  let quantity_in_cart;
  let targetElement;

  if (isSquareSwatch) {
    const swatchWrapper = squareSwatchEl.closest(".swatch-input__label__wrapper");
    const input = swatchWrapper?.querySelector(".swatch-input__input");
    if (input) {
      targetElement = input;
      input.checked = true;
      variantId = input.dataset.variantId;
      quantity_in_cart = input.dataset.quantityInCart;
    }
  } else if (isDropdownSwatch) {
    targetElement = dropdownOptionEl;
    variantId = dropdownOptionEl.dataset.id;
    quantity_in_cart = dropdownOptionEl.dataset.quantityInCart;
  }

  if (!variantId) return;

  const variant = parsedProductData.variants.find((v) => v.id == variantId);
  const productTabsMap = parsedProductData?.product_tabs || {};
  if (!variant) return;

  // === Apply UI updates in both quick view and PDP ===
  updateSelectedVariantId(productWrapper, variant);
  updateSelectedSwatch(productWrapper, variant, squareSwatchEl || dropdownOptionEl || target, isSquareSwatch);
  updateVariantTitle(productWrapper, variant);
  updateProductDescription(productWrapper, variant);
  updateAddToBagStatus(productWrapper, variant);
  updateHudaShade(productWrapper, variant);
  updateWaitlistDisplayQuickView(productWrapper, variant, quickViewModal);
  updateOutOfStockDisplayQuickView(productWrapper, variant, quickViewModal, parsedProductData);
  updatePrice(productWrapper, variant);
  updateSavePercentage(productWrapper, variant);


  // Custom Actions For PDP
  if (isPDPOnly) {
    updateQuantityRoles(productWrapper, variant, quantity_in_cart, targetElement);
    updateURL(variant);
    updateStickyImage(productWrapper, variant);
    updateStickyAddToBag(productWrapper, variant);
    updateSelectedVariantIdSticky(productWrapper, variant);
    updateWaitlistDisplay(productWrapper, variant);
    updateOutOfStockDisplay(productWrapper, variant);
    updateHazmatRestrictionUI(productWrapper, variant);
    updateTabsForVariant(productWrapper, variant, productTabsMap);
  }
});

const getSwatchVisualInfo = (swatchElement) => {
  if (!swatchElement) return null;

  const type = swatchElement.dataset.swatchType || null;

  if (type === "image") {
    const dataImage = swatchElement.dataset.swatchImage;
    const imgTag = swatchElement.querySelector("img");
    const image = dataImage || imgTag?.getAttribute("src") || null;
    return { type: "image", image, color: null };
  }

  if (type === "color") {
    const dataColor = swatchElement.dataset.swatchColor;
    const color = dataColor || getComputedStyle(swatchElement).backgroundColor;
    return { type: "color", color, image: null };
  }

  const fallbackColor = getComputedStyle(swatchElement).backgroundColor;
  return { type: "color", color: fallbackColor, image: null };
};

const updateTabsForVariant = (productRoot, selectedVariant, productTabsMap) => {
  if (!productRoot || !selectedVariant) return;

  const tabNodes = productRoot.querySelectorAll(".product__accordion .accordion__content[data-mf-key]");

  tabNodes.forEach((node) => {
    const key = node.dataset.mfKey || "";
    const wrap = node.closest(".collapsible__product__accordion");
    const details = node.closest("details");

    if (!key) return;

    const variantTabs = selectedVariant?.tabs || {};
    const variantHtml = variantTabs?.[key] || "";
    const productHtml = productTabsMap?.[key] || "";

    const htmlToUse = variantHtml || productHtml || "";

    if (htmlToUse) {
      if (node.innerHTML !== htmlToUse) {
        node.innerHTML = htmlToUse;
      }
      details?.removeAttribute("hidden");
      wrap?.removeAttribute("hidden");
    } else {
      if (node.innerHTML !== "") node.innerHTML = "";
      details?.setAttribute("hidden", "hidden");
      wrap?.setAttribute("hidden", "hidden");
    }
  });
};

const computeEffectiveWaitlist = (variant) => {
  const precomputed = variant?.metafields?.custom?.effectiveWaitlist;
  if (typeof precomputed !== "undefined") {
    return precomputed === true || precomputed === "true";
  }

  const enableWaitlist =
    variant?.metafields?.custom?.enableWaitlist === true || variant?.metafields?.custom?.enableWaitlist === "true";
  return enableWaitlist === true;
};

const getWaitlistState = (variant) => {
  const effectiveWaitlist = computeEffectiveWaitlist(variant);
  const backInStockDisabled =
    variant?.metafields?.custom?.backInStock === true || variant?.metafields?.custom?.backInStock === "true";

  return { effectiveWaitlist, backInStockDisabled };
};

const isLoyaltyLogin = (root) => Boolean(root?.querySelector?.("[data-loyalty-login='true']"));

// === Quick View Filter Function ===
const filterShadesQuickView = (context) => {
  const skinToneSelector = 'input[name="skin-tone--quickview"]';
  const undertoneSelector = 'input[name="undertone--quickview"]';
  const selectedShade = context.querySelector(`${skinToneSelector}:checked`)?.value;
  const selectedUndertone = context.querySelector(`${undertoneSelector}:checked`)?.value;

  if (!selectedShade || !selectedUndertone) return;

  const existedSt = new Set();
  const existedUt = new Set();

  context.querySelectorAll(".attr-main-wrapper").forEach((el) => {
    const st = el.dataset.st;
    const ut = el.dataset.ut;
    const showByShade = selectedShade === "All" || st === selectedShade;
    const showByUndertone = selectedUndertone === "All" || ut === selectedUndertone;
    el.classList.toggle("hide-shade", !(showByShade && showByUndertone));
  });

  const toggleOptions = (selector, existedSet) => {
    context.querySelectorAll(selector).forEach((el) => {
      el.classList.toggle("disabled", !existedSet.has(el.value) && el.value !== "All");
    });
  };

  context
    .querySelectorAll(`.attr-main-wrapper${selectedShade === "All" ? "[data-st]" : `[data-st="${selectedShade}"]`}`)
    .forEach((el) => existedUt.add(el.dataset.ut));
  toggleOptions(".undertone-options .shade-option", existedUt);

  context
    .querySelectorAll(
      `.attr-main-wrapper${selectedUndertone === "All" ? "[data-ut]" : `[data-ut="${selectedUndertone}"]`}`,
    )
    .forEach((el) => existedSt.add(el.dataset.st));
  toggleOptions(".skin-tone-options .shade-option", existedSt);
};

// === Helper Functions ===
const updateSelectedVariantId = (productWrapper, variant) => {
  const selectedSwatchInput = productWrapper.querySelector(".product-variant-id");
  const selectedStickyAtcInput = productWrapper.querySelector(".sticky-atc-mobile .product-variant-id");
  if (selectedSwatchInput) selectedSwatchInput.value = variant.id;
  if (selectedStickyAtcInput) selectedStickyAtcInput.value = variant.id;
};

const updateQuantityRolesPDP = (productWrapper, response) => {
  if (productWrapper) {
    const currentQuantity = response.quantity;
    const quantityInput = productWrapper.querySelector('input[name="quantity"]');
    const plusBtn = productWrapper.querySelector(".product-page .product-form__actions .quantity__button[name='plus']");
    if (!quantityInput) return;

    quantityInput.value = 1;
    quantityInput.setAttribute("data-cart-quantity", currentQuantity);
    const swatchElements = productWrapper.querySelectorAll(`[data-id="${response.variant_id}"]`);
    const squareswatchElements = productWrapper.querySelectorAll(`[data-variant-id="${response.variant_id}"]`);

    swatchElements.forEach((swatchElement) => {
      swatchElement.setAttribute("data-quantity-in-cart", currentQuantity);
    });

    squareswatchElements.forEach((swatchElement) => {
      swatchElement.setAttribute("data-quantity-in-cart", currentQuantity);
    });

    plusBtn?.classList.remove("disabled");
  }
};

const syncDropdownOptionUI = (optionEl, variant, swatchInfo) => {
  if (!optionEl) return;

  const wrapper = optionEl.closest(".custom-select-wrapper");
  if (!wrapper) return;

  const customSelect = wrapper.querySelector(".custom-select");
  if (!customSelect) return;

  const labelEl = customSelect.querySelector(".option-value");
  if (labelEl) {
    labelEl.textContent = variant?.title || optionEl.textContent.trim();
  }

  const undertoneEl = customSelect.querySelector(".variant-undertone");
  const ut = optionEl.dataset.ut;
  if (undertoneEl) {
    if (ut) {
      const formatted = ut.charAt(0).toUpperCase() + ut.slice(1);
      undertoneEl.textContent = window.variantStrings.undertoneLabel.replace("[value]", formatted);
    } else {
      undertoneEl.textContent = "";
    }
  }

  const preview =
    customSelect.querySelector(".product-square-swatch") || customSelect.querySelector(".color-swatch");

  if (preview) {
    let image = null;
    let color = null;

    if (swatchInfo?.type === "image" && swatchInfo.image) {
      image = swatchInfo.image;
    } else if (swatchInfo?.type === "color" && swatchInfo.color) {
      color = swatchInfo.color;
    } else {
      const optSwatch = optionEl.querySelector(".color-swatch");
      const swatchType = optSwatch?.dataset.swatchType;
      const swatchImage = optSwatch?.dataset.swatchImage;
      const swatchColor = optSwatch?.dataset.swatchColor || optionEl.dataset.optionSwatchValue || "";

      if (swatchType === "image" || swatchImage) {
        image = swatchImage;
      } else {
        color = swatchColor;
      }
    }

    if (image) {
      preview.style.background = "transparent";
      let img = preview.querySelector("img");
      if (!img) {
        img = document.createElement("img");
        img.setAttribute("width", "100%");
        img.setAttribute("height", "100%");
        preview.appendChild(img);
      }
      img.src = image;
      preview.dataset.swatchType = "image";
      preview.dataset.swatchImage = image;
      delete preview.dataset.swatchColor;
    } else {
      const existingImg = preview.querySelector("img");
      if (existingImg) existingImg.remove();
      preview.style.backgroundColor = color || "transparent";
      preview.dataset.swatchType = "color";
      preview.dataset.swatchColor = color || "";
      delete preview.dataset.swatchImage;
    }
  }

  const selectedNewBadge = customSelect.querySelector(".selected-new-badge");
  if (selectedNewBadge) {
    selectedNewBadge.style.display = optionEl.dataset.isNew === "true" ? "" : "none";
  }

  const allOptions = wrapper.querySelectorAll(".custom-option");
  allOptions.forEach((opt) => opt.classList.remove("selected"));
  optionEl.classList.add("selected");
};


const updateSelectedDropdownSwatch = (productWrapper, variant, swatchInfo) => {
  const swatches = productWrapper.querySelectorAll(".product-dropdown-swatch");
  if (!swatches.length) {
    updateAllDropdownVariant(variant, swatchInfo);
    return;
  }

  const matchElements = [...swatches].filter((s) => s.dataset.id == variant.id);
  if (!matchElements.length) return;

  matchElements.forEach((matchElement) => {
    syncDropdownOptionUI(matchElement, variant, swatchInfo);
  });
};

const updateSelectedSwatch = (productWrapper, variant, target, isSquareSwatch) => {
  const swatches = productWrapper.querySelectorAll(".swatch-input__input");

  const getInfoFromWrapper = (wrapper) => {
    if (!wrapper) return null;
    const swatchEl = wrapper.querySelector(".product-square-swatch") || wrapper.querySelector(".color-swatch");
    return getSwatchVisualInfo(swatchEl);
  };

  if (isSquareSwatch) {
    const swatchWrapper = target.closest(".swatch-input__label__wrapper");
    const swatchInfo = getInfoFromWrapper(swatchWrapper);
    updateSelectedDropdownSwatch(productWrapper, variant, swatchInfo);
  } else if (swatches.length) {
    const matchInput = [...swatches].find((s) => s.dataset.variantId == variant.id);

    if (matchInput) {
      swatches.forEach((s) => (s.checked = false));
      matchInput.checked = true;

      const swatchWrapper = matchInput.closest(".swatch-input__label__wrapper");
      const swatchInfo = getInfoFromWrapper(swatchWrapper);
      updateSelectedDropdownSwatch(productWrapper, variant, swatchInfo);
    }
  } else {
    updateAllDropdownVariant(variant, null);
  }
};

const updateAllDropdownVariant = (variant, swatchInfo) => {
  const allDropdowns = document.querySelectorAll(".custom-select-wrapper");

  allDropdowns.forEach((dropdown) => {
    const options = dropdown.querySelectorAll(".custom-option.product-dropdown-swatch");
    if (!options.length) return;

    const matchedOption = [...options].find((option) => option.dataset.id == variant.id);
    if (!matchedOption) return;

    syncDropdownOptionUI(matchedOption, variant, swatchInfo);
  });
};

const updateVariantTitle = (productWrapper, variant) => {
  const variantTitleEl = productWrapper.querySelector(".selected-variant__title");
  if (variantTitleEl) variantTitleEl.innerHTML = variant.title || "";
};

const updateProductDescription = (productWrapper, variant) => {
  const descriptionElements = productWrapper.querySelectorAll(".product__description");
  if (descriptionElements) {
    const shortDesc = variant?.metafields?.custom?.shortDescription || "";
    const size = variant?.metafields?.custom?.size || "";
    descriptionElements.forEach((descriptionElement) => {
      let content = shortDesc || "";
      if (size) {
        content += (shortDesc ? " ● " : "● ") + size;
      }
      descriptionElement.innerHTML = content;
    });
  }
};

const updateAddToBagStatus = (productWrapper, variant) => {
  const addToBagBtn = productWrapper.querySelector(".product-form__submit");
  if (addToBagBtn) {
    if (variant.available) {
      addToBagBtn.removeAttribute("disabled");
      if (addToBagBtn?.hasAttribute("preorder")) {
        addToBagBtn.textContent = "Pre-Order";
      }
    } else {
      addToBagBtn.setAttribute("disabled", true);
      if (addToBagBtn?.hasAttribute("preorder")) {
        addToBagBtn.textContent = "Out Of Stock";
      }
    }
  }
};

const updateHudaShade = (productWrapper, variant) => {
  const badges = productWrapper.querySelectorAll(".hudas-badge");
  const isHudaShade = variant?.metafields?.custom?.isHudaShade;
  badges.forEach((badge) => {
    if (badge) badge.classList.toggle("hide", !isHudaShade);
  });
};

const updateQuantityRoles = (productWrapper, variant, quantity_in_cart, targetElement) => {
  const quantityInput = productWrapper.querySelector('.product-page input[name="quantity"]');
  if (!quantityInput) return;

  const plusBtn = productWrapper.querySelector(".product-page .product-form__actions .quantity__button[name='plus']");
  const minusBtn = productWrapper.querySelector(".product-page .product-form__actions .quantity__button[name='minus']");
  const addToBagBtn = productWrapper.querySelector(".buy-buttons-container .product-form__submit");

  plusBtn?.classList.remove("disabled");

  if (variant.available && variant.max_product_quantity != 0) {
    quantityInput.value = 1;
  } else if (variant.max_product_quantity == 0) {
    quantityInput.value = 0;
    plusBtn?.classList.remove("disabled");
    minusBtn.classList.remove("disabled");
    addToBagBtn?.setAttribute("disabled", true);
    if (addToBagBtn?.hasAttribute("preorder")) {
      addToBagBtn.textContent = "Out Of Stock";
    }
  } else {
    quantityInput.value = 0;
    if (addToBagBtn?.hasAttribute("preorder")) {
      addToBagBtn.textContent = "Out Of Stock";
    }
  }

  const invQty = variant?.inventory;
  const maxQty = variant?.max_product_quantity;

  quantityInput.setAttribute("data-cart-quantity", quantity_in_cart);
  if (targetElement) {
    targetElement.setAttribute("data-quantity-in-cart", quantity_in_cart);
  }

  let maxProductQuantity = 0;
  const isInvQtyValid = typeof invQty === "number" && !isNaN(invQty);
  const isMaxQtyValid = typeof maxQty === "number" && !isNaN(maxQty);

  if (isInvQtyValid && isMaxQtyValid) {
    maxProductQuantity = Math.min(Number(invQty), Number(maxQty));
  } else if (isMaxQtyValid) {
    maxProductQuantity = Number(maxQty);
  } else if (isInvQtyValid) {
    maxProductQuantity = Number(invQty);
  } else {
    quantityInput.removeAttribute("max");
  }

  if (maxProductQuantity >= 0) {
    quantityInput.setAttribute("max", maxProductQuantity);
    const maxQuantityInput = productWrapper.querySelector('input[name="max-quantity"]');
    const maxInventoryInput = productWrapper.querySelector('input[name="inventory-quantity"]');

    const maxQuantityStickyAtcInput = productWrapper.querySelector('.sticky-atc-mobile input[name="max-quantity"]');
    const maxInventoryStickyAtcInput = productWrapper.querySelector(
      '.sticky-atc-mobile input[name="inventory-quantity"]',
    );

    if (maxQuantityInput) maxQuantityInput.value = maxProductQuantity;
    if (maxInventoryInput) maxInventoryInput.value = invQty;
    if (maxQuantityStickyAtcInput) maxQuantityStickyAtcInput.value = maxProductQuantity;
    if (maxInventoryStickyAtcInput) maxInventoryStickyAtcInput.value = invQty;
  }

  // Notify the PDP inline quantity selector so it swaps between ATC and the
  // selector based on the new variant's qty already in the cart.
  // Skip the dispatch when this call comes from a bundle context
  const isBundleContext =
    !!(targetElement && targetElement.classList && targetElement.classList.contains("bundled-option"));
  if (!isBundleContext) {
    try {
      const cartQty = parseInt(quantity_in_cart, 10);
      document.dispatchEvent(
        new CustomEvent("pdp-inline-quantity:sync", {
          detail: {
            variantId: variant.id,
            quantity: Number.isFinite(cartQty) ? cartQty : 0,
          },
        }),
      );
    } catch {}
  }

  if (!variant.available) {
    plusBtn?.classList.add("disabled");
  }
};

const updatePrice = (productWrapper, variant) => {
  const priceElements = productWrapper.querySelectorAll(".product-price");
  const compareAtPriceElements = productWrapper.querySelectorAll(".product-compare-at-price");
  const savePriceElements = productWrapper.querySelectorAll(".product-save-price");

  priceElements.forEach((el) => (el.innerHTML = variant.price || ""));
  if (compareAtPriceElements) {
    compareAtPriceElements.forEach((el) => (el.innerHTML = variant.compare_at_price || ""));
  }
  if (savePriceElements) {
    savePriceElements.forEach((el) => (el.innerHTML = variant.save_price || ""));
  }
};

const updateSavePercentage = (productWrapper, variant) => {
    if (window.updateSavePercentageBadge) {
    window.updateSavePercentageBadge(productWrapper, variant);
  }
};

const updateURL = (variant) => {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variant.id);
  window.history.replaceState({}, "", url);
};

const updateStickyImage = (productWrapper, variant) => {
  const updated_image = variant?.metafields?.custom?.image_url?.[0];

  const primary_image = productWrapper.querySelector(".card-variant-selected-image");
  if (primary_image && updated_image) {
    primary_image.src = updated_image;
  }
};

const updateStickyAddToBag = (productWrapper, variant) => {
  const addToBagBtn = productWrapper.querySelector(".add-to-cart-panel .product-form__submit");
  const sticky_add_to_bag = productWrapper.querySelector(".sticky-atc-mobile .product-form__submit");

  if (addToBagBtn) {
    if (variant.available) {
      addToBagBtn.removeAttribute("disabled");
      sticky_add_to_bag.removeAttribute("disabled");
      if (addToBagBtn?.hasAttribute("preorder")) {
        addToBagBtn.textContent = "Pre-Order";
        sticky_add_to_bag.textContent = "Pre-Order";
      }
    } else {
      addToBagBtn.setAttribute("disabled", true);
      sticky_add_to_bag.setAttribute("disabled", true);
      if (addToBagBtn?.hasAttribute("preorder")) {
        addToBagBtn.textContent = "Out Of Stock";
        sticky_add_to_bag.textContent = "Out Of Stock";
      }
    }
  }
};

const updateSelectedVariantIdSticky = (productWrapper, variant) => {
  const selectedSwatchInput = productWrapper.querySelector(".add-to-cart-panel .product-variant-id");
  if (selectedSwatchInput) selectedSwatchInput.value = variant.id;
};

const updateOutOfStockDisplay = (productWrapper, variant) => {
  const backInStockButtons = productWrapper.querySelector(".product-back-in-stock-buttons");
  const productFormButtons = productWrapper.querySelector(".product-form__buttons");
  const productQuantity = productWrapper.querySelector(".product-form__quantity");

  if (!backInStockButtons) {
    return;
  }

  // Check for the variant_online metafield
  if (variant.metafields?.custom?.variant_online === false) {
    backInStockButtons.innerHTML = `
      <button type="button" class="back-in-stock-btn" disabled>
        ${window.variantStrings.unavailable}
      </button>
    `;
    return;
  }

  const { effectiveWaitlist, backInStockDisabled } = getWaitlistState(variant);

  // Check if waitlist should be shown (takes priority)
  const shouldShowWaitlist =
    effectiveWaitlist && (variant.available || (variant.inventory == 0 && backInStockDisabled));

  // If waitlist should be shown, don't show out-of-stock
  if (shouldShowWaitlist) {
    backInStockButtons.innerHTML = "";
    // Don't return here - let the function continue to handle buy button display
  }

  // New out-of-stock logic: 2 cases (only if not waitlist)
  // 1. Inventory = 0 AND back_in_stock_disabled = true AND waitlist = false/empty (out of stock button)
  // 2. Inventory = 0 AND back_in_stock_disabled = false/empty (back in stock form)
  const shouldShowOutOfStock = variant.inventory == 0 && backInStockDisabled && !effectiveWaitlist;
  const shouldShowBackInStock = variant.inventory == 0 && !backInStockDisabled;

  if (shouldShowOutOfStock) {
    productFormButtons.classList.add("hide");
    if (productQuantity) productQuantity.classList.add("hide");

    // Make sure the container is visible
    backInStockButtons.style.display = "block";

    backInStockButtons.innerHTML = `
      <button
        type="button"
        class="button button--full-width out-of-stock-btn">
        ${window.getStockStatusLabel?.(variant.handle) || window.variantStrings?.soldOut}
      </button>
    `;

    // Remove any inline styles that might hide the container and its parent
    backInStockButtons.style.display = "block";

    // Also fix the parent container if it exists
    const parentContainer = backInStockButtons.parentElement;
    if (parentContainer && parentContainer.classList.contains("back-in-stock-container")) {
      parentContainer.style.display = "block";
    }
  } else if (shouldShowBackInStock) {
    productFormButtons.classList.add("hide");
    if (productQuantity) productQuantity.classList.add("hide");

    // Make sure the container is visible - remove any inline styles that might hide it
    backInStockButtons.style.display = "block";

    // Also fix the parent container if it exists
    const parentContainer = backInStockButtons.parentElement;
    if (parentContainer && parentContainer.classList.contains("back-in-stock-container")) {
      parentContainer.style.display = "block";
    }

    // Get region value from global region input
    const globalRegionInput = document.querySelector("#global-region");
    const region = globalRegionInput ? globalRegionInput.value : "NA";

    backInStockButtons.innerHTML = `
      <p class="back-in-stock-label">Email me when this product is back in stock</p>
      <div class="back-in-stock-form" selected-sku="${variant.sku}" selected-region="${region}" region-with-sku="${variant.sku}-${region}">
      <form id="BackInStockForm" class="back_in_stock_form">
        <input type="hidden" id="back-in-stock-region" value="${region}">
        <input
          class="field__input"
          type="text"
          type="email"
          id="back-in-stock-email"
          placeholder="Enter Email Address"
        >
        <button type="button" class="button button--primary notify-me-btn">Notify Me</button>
        </form>
      </div>
      <div class="back-in-stock-message"></div>
      <div class="back-in-stock-agree-terms">${window.variantStrings?.notifyDisclaimerHtml || ""}</div>
    `;
  } else {
    // Show buy buttons and clear back-in-stock content for available variants
    productFormButtons.classList.remove("hide");
    if (productQuantity) productQuantity.classList.remove("hide");
    backInStockButtons.innerHTML = "";
  }

  // If waitlist should be shown, make sure buy buttons are hidden and don't touch waitlist container
  if (shouldShowWaitlist) {
    productFormButtons.classList.add("hide");
    if (productQuantity) productQuantity.classList.add("hide");
    // Don't touch waitlist container - let updateWaitlistDisplay handle it
  }
};

const updateOutOfStockDisplayQuickView = (productWrapper, variant, quickViewModal, parsedProductData) => {
  if (quickViewModal) {
    const backInStockButtons = productWrapper.querySelector(".product-back-in-stock-buttons");
    const productFormButtons = productWrapper.querySelector(".product-form__buttons");
    const productQuantity = productWrapper.querySelector(".product-form__quantity");

    if (!backInStockButtons) {
      return;
    }

    // Check for the variant_online metafield
    if (variant.metafields?.custom?.variant_online === false) {
      backInStockButtons.innerHTML = `
        <button type="button" class="back-in-stock-btn" disabled>
          ${window.variantStrings.unavailable}
        </button>
      `;
      return;
    }

    const { effectiveWaitlist, backInStockDisabled } = getWaitlistState(variant);

    // Check if waitlist should be shown (takes priority)
    const shouldShowWaitlist =
      effectiveWaitlist && (variant.available || (variant.inventory == 0 && backInStockDisabled));

    // If waitlist should be shown, don't show out-of-stock
    if (shouldShowWaitlist) {
      backInStockButtons.innerHTML = "";
      // Don't return here - let the function continue to handle buy button display
    }

    // New out-of-stock logic: 2 cases (only if not waitlist)
    // 1. Inventory = 0 AND back_in_stock_disabled = true AND waitlist = false/empty (out of stock button)
    // 2. Inventory = 0 AND back_in_stock_disabled = false/empty (back in stock form)
    const shouldShowOutOfStock = variant.inventory == 0 && backInStockDisabled && !effectiveWaitlist;
    const shouldShowBackInStock = variant.inventory == 0 && !backInStockDisabled;

    if (shouldShowOutOfStock) {
      productFormButtons.classList.add("hide");
      if (productQuantity) productQuantity.classList.add("hide");

      // Make sure the container is visible
      backInStockButtons.style.display = "block";

      backInStockButtons.innerHTML = `
        <button
          type="button"
          class="button button--full-width out-of-stock-btn">
          ${window.getStockStatusLabel?.(variant.handle) || window.variantStrings?.soldOut}
        </button>
      `;

      // Remove any inline styles that might hide the container and its parent
      backInStockButtons.style.display = "block";

      // Also fix the parent container if it exists
      const parentContainer = backInStockButtons.parentElement;
      if (parentContainer && parentContainer.classList.contains("back-in-stock-container")) {
        parentContainer.style.display = "block";
      }
    } else if (shouldShowBackInStock) {
      productFormButtons.classList.add("hide");
      if (productQuantity) productQuantity.classList.add("hide");

      // Make sure the container is visible - remove any inline styles that might hide it
      backInStockButtons.style.display = "block";

      // Also fix the parent container if it exists
      const parentContainer = backInStockButtons.parentElement;
      if (parentContainer && parentContainer.classList.contains("back-in-stock-container")) {
        parentContainer.style.display = "block";;
      }

      let productHandle = productWrapper.dataset.handle || parsedProductData.handle || variant.handle;
      const root = window.Shopify?.routes?.root || "/";
      const productUrl = `${root}products/${productHandle || ""}`;
      backInStockButtons.innerHTML = `
        <div class="back-in-stock-form" data-variant-id="${variant.id}">
          <a href="${productUrl}" class="button button--primary notify-me-btn">Notify Me</a>
        </div>
      `;
    } else {
      productFormButtons.classList.remove("hide");
      if (productQuantity) productQuantity.classList.remove("hide");
      backInStockButtons.innerHTML = "";
    }

    // If waitlist should be shown, make sure buy buttons are hidden
    if (shouldShowWaitlist) {
      productFormButtons.classList.add("hide");
    }
  }
};

const updateWaitlistDisplay = (productWrapper, variant) => {
  const productFormButtons = productWrapper.querySelector(".product-form__buttons");
  const productQuantity = productWrapper.querySelector(".product-form__quantity");
  const waitlistContainer = productWrapper.querySelector(".waitlist-container");

  if (!productFormButtons || isLoyaltyLogin(productWrapper)) return;

  // New waitlist logic: 2 cases
  // 1. Variant available AND waitlist = true
  // 2. Inventory = 0 AND waitlist = true AND back_in_stock_disabled = true
  const { effectiveWaitlist, backInStockDisabled } = getWaitlistState(variant);

  const shouldShowWaitlist =
    effectiveWaitlist && (variant.available || (variant.inventory == 0 && backInStockDisabled));

  if (shouldShowWaitlist) {
    // Hide buy buttons when waitlist is enabled
    productFormButtons.classList.add("hide");
    if (productQuantity) productQuantity.classList.add("hide");

    if (waitlistContainer) {
      waitlistContainer.style.display = "block";

      // Update waitlist-id attribute with current variant's waitlist ID or SKU as fallback
      const waitlistForm = waitlistContainer.querySelector(".waitlist-form");
      if (waitlistForm) {
        const waitlistId = variant?.metafields?.custom?.waitListID;
        const fallbackId = waitlistId && waitlistId.trim() !== "" ? waitlistId : variant?.sku;
        if (fallbackId) {
          waitlistForm.setAttribute("waitlist-id", fallbackId);
        }

        // Clear waitlist form input and messages when variant changes
        const emailInput = waitlistForm.querySelector("#waitlist-email, input[type='email']");
        if (emailInput) {
          emailInput.value = "";
        }

        // Clear any error/success messages
        const messageDiv = waitlistContainer.querySelector(".waitlist-message");
        if (messageDiv) {
          messageDiv.innerHTML = "";
          messageDiv.className = "waitlist-message";
          messageDiv.style.display = "none";
        }
      }
    }
  } else {
    // Show buy buttons when waitlist is disabled
    productFormButtons.classList.remove("hide");
    if (productQuantity) productQuantity.classList.remove("hide");

    if (waitlistContainer) {
      waitlistContainer.style.display = "none";
    }
  }
};

const updateWaitlistDisplayQuickView = (productWrapper, variant, quickViewModal) => {
  if (!quickViewModal) return;

  const productFormButtons = productWrapper.querySelector(".product-form__buttons");
  const productQuantity = productWrapper.querySelector(".product-form__quantity");
  const waitlistContainer = productWrapper.querySelector(".waitlist-container");

  if (!productFormButtons || isLoyaltyLogin(productWrapper)) return;

  // New waitlist logic: 2 cases
  // 1. Variant available AND waitlist = true
  // 2. Inventory = 0 AND waitlist = true AND back_in_stock_disabled = true
  const { effectiveWaitlist, backInStockDisabled } = getWaitlistState(variant);

  const shouldShowWaitlist =
    effectiveWaitlist && (variant.available || (variant.inventory == 0 && backInStockDisabled));

  if (shouldShowWaitlist) {
    // Hide buy buttons when waitlist is enabled
    productFormButtons.classList.add("hide");
    if (productQuantity) productQuantity.classList.add("hide");

    if (waitlistContainer) {
      waitlistContainer.style.display = "block";

      // Update waitlist-id attribute with current variant's waitlist ID or SKU as fallback
      const waitlistForm = waitlistContainer.querySelector(".waitlist-form");
      if (waitlistForm) {
        const waitlistId = variant?.metafields?.custom?.waitListID;
        const fallbackId = waitlistId && waitlistId.trim() !== "" ? waitlistId : variant?.sku;
        if (fallbackId) {
          waitlistForm.setAttribute("waitlist-id", fallbackId);
        }
      }
    }
  } else {
    // Show buy buttons when waitlist is disabled
    productFormButtons.classList.remove("hide");
    if (productQuantity) productQuantity.classList.remove("hide");

    if (waitlistContainer) {
      waitlistContainer.style.display = "none";
    }
  }
};

const updateHazmatRestrictionUI = (productWrapper, variant) => {
  // Shared inputs
  const thresholdInput = productWrapper.querySelector("input.hazmat-country-threshold");
  if (!thresholdInput) return;
  const threshold = thresholdInput ? parseFloat(thresholdInput.value) : 0;
  const quantityInput = productWrapper.querySelector('.product-page input[name="quantity"]');
  const plusBtn = productWrapper.querySelector(".product-page .product-form__actions .quantity__button[name='plus']");

  const panels = [
    productWrapper,
    productWrapper.querySelector(".add-to-cart-panel"),
    productWrapper.querySelector(".sticky-atc-mobile"),
  ].filter(Boolean);

  const scopes = panels.map((root) => {
    const errWrap =
      root.querySelector(".product-form__error-message-wrapper.pdp") ||
      root.querySelector('.product-form__error-message-wrapper[data-form-id="sticky-add-to-cart-form"]') ||
      root.querySelector(".add-to-cart-panel .product-form__error-message-wrapper");

    return {
      btn: root.querySelector(".product-form__submit"),
      errWrap,
      errText: errWrap?.querySelector(".product-form__error-message"),
    };
  });

  scopes.forEach(({
    errWrap,
    errText
  }) => {
    if (errWrap) errWrap.setAttribute("hidden", true);
    if (errText) errText.textContent = "";
  });

  const isHazmat = variant?.metafields?.custom?.isHazmatItem === "true";
  if (!isHazmat) {
    scopes.forEach(({
      btn
    }) => {
      if (!btn) return;
      if (variant?.available) {
        btn.removeAttribute("disabled");
        if (btn.hasAttribute("preorder")) btn.textContent = "Pre-Order";
      } else {
        btn.setAttribute("disabled", true);
        if (btn.hasAttribute("preorder")) btn.textContent = "Out Of Stock";
      }
    });
    return;
  }

  const hazmatVolume = parseFloat(variant?.metafields?.custom?.hazmatVolume || 0);
  const exceedsThreshold = hazmatVolume >= threshold;

  if (exceedsThreshold) {
    scopes.forEach(({
      btn,
      errWrap,
      errText
    }) => {
      if (btn) btn.setAttribute("disabled", true);
      if (errWrap) errWrap.removeAttribute("hidden");
      if (errText) errText.textContent = window.variantStrings.hazmatRestrictedMessage;
    });
    if (quantityInput) {
      quantityInput.value = 0;
      quantityInput.setAttribute("max", 0);
    }
    plusBtn?.classList.add("disabled");
  } else {
    scopes.forEach(({
      btn
    }) => {
      if (!btn) return;
      if (variant?.available) {
        btn.removeAttribute("disabled");
        if (btn.hasAttribute("preorder")) btn.textContent = "Pre-Order";
      } else {
        btn.setAttribute("disabled", true);
        if (btn.hasAttribute("preorder")) btn.textContent = "Out Of Stock";
      }
    });
  }
};
